<template>
    <v-tab-item>
        <v-sheet v-if="!micepecRecords.length" class="page-text grey-6--text text-center"> 마이스펙 이력이 없습니다. </v-sheet>
        <template v-else>
            <p class="page-text--sm grey-6--text mb-8 mb-lg-12">
                마이스펙 이력은 해당 지원자의 역량이 마이스펙을 통해 인증되었다는 것을 증명합니다
            </p>
            <v-divider class="primary border-2 mb-12 mb-lg-24" />
            <v-sheet>
                <template v-for="item in micepecRecords">
                    <micepec-record-item v-bind="{ item, mode }" class="micepec-record-item" :key="item._id" />
                </template>
            </v-sheet>
        </template>
    </v-tab-item>
</template>

<script>
import MicepecRecordItem from "@/components/client/application/micepec-records/micepec-record-item.vue";
import api from "@/api";

export default {
    components: {
        MicepecRecordItem,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
    },
    data: () => ({
        mode: "view",
        micepecRecords: [],
    }),
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
    },
    methods: {
        async init() {
            let { _recruitment, _id: _application } = this.value;
            if (_recruitment && _application) {
                let { micepecRecords } = await api.v1.company.recruitments.applications.micepecRecords.gets({ _recruitment, _application });
                this.micepecRecords = micepecRecords;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.micepec-record-item:not(:last-child) {
    margin-bottom: 12px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .micepec-record-item:not(:last-child) {
        margin-bottom: 24px;
    }
}
@media (min-width: 1200px) {
}
</style>
